import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaddaModule } from 'angular2-ladda';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SelectButtonModule } from 'primeng/primeng';
import { ToggleButtonModule } from 'primeng/primeng';
import { AccordionModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { StepsModule, GrowlModule, SharedModule, TabViewModule, InputMaskModule } from 'primeng/primeng';
import { FormsExtensionsModule } from './forms/forms-extensions.module';
import { RemplaceCharacter } from './forms/replaceCharacter.pipe';

//SLIDER COMPONENTE
import { LottoSliderModule } from "./slider/lotto.slider.component";

@NgModule({
  imports: [
    CommonModule,
    FormsExtensionsModule,
    GrowlModule,
    ModalModule,
  ],
  declarations: [
    RemplaceCharacter
  ],
  exports: [
    CommonModule,
    LaddaModule,
    ModalModule,
    BsDropdownModule,
    TabsModule,
    SelectButtonModule,
    ToggleButtonModule,
    AccordionModule,
    ChartsModule,
    CalendarModule,
    StepsModule,
    CarouselModule,
    PopoverModule,
    GrowlModule,
    FormsExtensionsModule,
    SharedModule,
    LottoSliderModule,
    TabViewModule,
    RemplaceCharacter,
    InputMaskModule,
  ]
})
export class CustomSharedModule { }



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/shared/shared.module.ts